export const bytes2Size = (byteVal: number, fractionDigits = 1) => {
  const units = ["Bytes", "KB", "MB", "GB", "TB"];
  let kounter = 0;
  const kb = 1024;
  let div = byteVal / 1;
  while (div >= kb) {
    kounter++;
    div = div / kb;
  }
  return div.toFixed(fractionDigits) + " " + units[kounter];
};
